import type { Provenance } from './types';

export const observed = (sourceIds: readonly string[], note: string): Provenance => ({
  status: 'OBSERVED',
  sourceIds,
  note,
});

export const corroborated = (sourceIds: readonly string[], note: string): Provenance => ({
  status: 'CORROBORATED',
  sourceIds,
  note,
});

export const sourced = (sourceIds: readonly string[], note: string): Provenance => ({
  status: 'SOURCED',
  sourceIds,
  note,
});

export const provisional = (note: string): Provenance => ({
  status: 'PROVISIONAL',
  sourceIds: ['AUTHORED-PLACEHOLDER'],
  note,
});
